/** Allocate whole sets across the session, preserving every block and at least one set per action. */
export function reducedSessionSets(counts: number[], reductionPercent: number): number[] {
  const result = counts.map(count => Math.max(0, Math.floor(count)));
  if (!Number.isFinite(reductionPercent) || reductionPercent <= 0) return result;
  const total = result.reduce((sum, count) => sum + count, 0);
  const removable = result.reduce((sum, count) => sum + Math.max(0, count - 1), 0);
  let remaining = Math.min(removable, Math.max(1, Math.round(total * Math.min(100, reductionPercent) / 100)));
  while (remaining > 0) {
    let selected = -1;
    for (let index = 0; index < result.length; index++) {
      if (result[index] > 1 && (selected < 0 || result[index] > result[selected])) selected = index;
    }
    if (selected < 0) break;
    result[selected]--; remaining--;
  }
  return result;
}
